import { render, staticRenderFns } from "./JustwatchTVPlayBtn.vue?vue&type=template&id=6837a1fb&scoped=true"
import script from "./JustwatchTVPlayBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./JustwatchTVPlayBtn.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./JustwatchTVPlayBtn.vue?vue&type=style&index=0&id=6837a1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837a1fb",
  null
  
)

export default component.exports